export class Collection {
  static AllCollections = 'AllCollections';
}
